// = Libs =
import { ChangeEvent, FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import InputMask from 'react-input-mask';

// = Styles =
import classes from './input.module.scss';

// = Types =
import { InputProps } from './input.types';

// = Components =

const Input: FC<InputProps> = (props) => {
  const {
    type = 'text',
    value = '',
    className = '',
    mask = '',
    name = '',
    placeholder = '',
    required = false,
    fullWidth = false,
    onChangeEvent,
    onChange,
    onBlur,
    onClick,
    min,
    max,
    disabled = false,
    border = '',
  } = props;

  const [inputValue, setInputValue] = useState<string | number>(value);
  const [isFocus, setIsFocus] = useState<boolean>(!!value);

  useEffect(() => {
    setInputValue(value);
    setIsFocus(!!value);
  }, [value]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setInputValue(e.target.value);

    onChange && onChange(e.target.value);
    onChangeEvent && onChangeEvent(e);
  };

  const handleBlur = (e: ChangeEvent<HTMLInputElement>): void => {
    setIsFocus(!!inputValue);

    onBlur && onBlur(e);
  };

  const handleFocus = (): void => {
    setIsFocus(true);
  };

  return (
    <div
      className={clsx(
        {
          [classes['input']]: true,
          [classes['input--full-width']]: fullWidth,
        },
        className
      )}>
      <InputMask
        disabled={disabled}
        type={type}
        value={inputValue}
        className={clsx({
          [classes['input__field']]: true,
          [classes['input__field--clear']]: !placeholder,
          [classes['input__border-question']]: border === 'question',
          [classes['input__border-answer']]: border === 'answer',
        })}
        mask={mask}
        name={name}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onClick={onClick}
        min={min}
        max={max}
      />

      {placeholder && (
        <span
          className={clsx({
            [classes['input__placeholder']]: true,
            [classes['input__placeholder--focus']]: isFocus,
          })}>
          {placeholder}
        </span>
      )}
    </div>
  );
};

export default Input;
